import 'jquery-ui';
import ko from 'knockout';
import { BlockPageHelper } from '../Helpers/helpers';
import { post } from "jquery";
import { Modal } from "bootstrap";
import { Toast } from "bootstrap";
const Genesis = require("../Genesis.js");
import { CategoryPathComponent } from '../Shared/CategoryPath/CategoryPathComponent';
let AutoComplete = require("./serviceRequestSearch.js");

export class ISiteMobileServiceRequestCreateSRFromAssetPage {
    private modal: Modal | null = null;
    private PropertyId: string = "";
    private LocationId: string = "";

    private category: CategoryPathComponent = new CategoryPathComponent({
        ModalId: 'classificationModal',
        Url: Genesis.url('/WorkOrder/_CategoryPath'),
        PathId: 'categoryPath',
        SelectButtonId: 'selectCategoryButton',
        IsReadOnly: false,
        PreventParentSelection: true,
        AllowMultiSelect: false,
        IsRequired: true,
        FormId: "CreateSRfromAssetForm"
    });

    constructor() {
    }

    public Init() {
        AutoComplete();
        this.PropertyId = $('#RelatedProperty').val() as string;
        this.LocationId = $("#LocationId").val() as string;

        if (this.PropertyId != "") {
            this.PopulateLocationDropdown(this.PropertyId, this.LocationId);
        }
        $("#idPreview").html('');
        $("#idPreview").hide();
        $("#frmContent").show();
        $("#hdnProcess").val("Edit");
        $("#classificationModal").detach().appendTo("#modalContainerPlaceholder");

        let $elements = $("[id^='classificationModal']");
        while ($elements.length >= 2) {
            $elements.first().remove();
            $elements = $("[id^='classificationModal']");
        }


        try {
            ko.applyBindings(this.category);
        }
        catch (e) {
            // Bindings already created, no need to do anything
        }

        $('#CreateSRfromAssetForm').off('submit');

        $("#btn-cancel").click((e: any) => {
            BlockPageHelper.block();
            $("#hdnProcess").val("Edit");
            $("#frmContent").show();
            $("#idPreview").html('');
            $("#idPreview").hide();
            $("#btn-cancel").text("Cancel");
            $("#saveSRFromAsset").text("Save");
            BlockPageHelper.unblock();
        });

        $("#saveSRFromAsset").click((e: any) => {
            BlockPageHelper.block();
            if ($("#hdnProcess").val() == "Edit") {
                const form = $('#CreateSRfromAssetForm')[0] as HTMLFormElement;
                if (form !== null) {
                    this.category.validateCategorySelected();
                    if (!form.checkValidity()) {
                        form.classList.add('was-validated');
                        BlockPageHelper.unblock();
                        return false;
                    }
                    else {
                        this.PreviewSRForm();
                    }
                }
            }
            else {
                this.SubmitSRForm();
            }
        });
    }

    private PreviewSRForm() {
        $("#hdnProcess").val("Preview");
        const formData = $("#CreateSRfromAssetForm").serialize();
        var saveSR: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveSR[pair[0]] = decodeURIComponent(pair[1]);
        });
        const url = Genesis.url('/ServiceRequest/PreviewSaveSR');
        $.post(url, { saveSR: saveSR }, function (responseResult) {
            $("#idPreview").html('');
            $("#frmContent").hide();
            $("#idPreview").show();
            BlockPageHelper.unblock();
            $("#idPreview").html(responseResult);
            $("#btn-cancel").text("Edit");
            $("#saveSRFromAsset").text("Submit");
            $('#btn-cancel').prepend('<i class="fas fa-edit"></i> ')
        });
    }

    private SubmitSRForm() {
        const formData = $("#CreateSRfromAssetForm").serialize();
        var saveSR: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveSR[pair[0]] = decodeURIComponent(pair[1]);
        });
        const url = Genesis.url('/ServiceRequest/SaveSRFromAsset');
        $.post(url, { saveSR: saveSR }, function (responseResult) {
            BlockPageHelper.unblock();
            $("#idPreview").html(responseResult);
            if (responseResult.status) {
                var msgSuccess = Toast.getOrCreateInstance("#msgSuccess");
                msgSuccess.show();
                const redirectUrl = Genesis.url('/ServiceRequest/GetServiceRequest?requestId=') + responseResult.serviceRequestid;
                window.location.href = redirectUrl;
            }
            else {
                var msgFailure = Toast.getOrCreateInstance("#msgFailure");
                msgFailure.show();
            }
        });
    }

    private PopulateLocationDropdown(propId: string, locId: string) {
        $.ajax({
            type: "GET",
            url: "LocationFilter",
            data: { propertyId: propId },
            success: function (data) {
                var s = '<option value="0">Please Select a Location</option>';
                for (var i = 0; i < data.length; i++) {
                    s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
                }
                $("#locationsDropdown").html(s);
                if (locId != "0" && locId != "") {
                    $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
                }
            }
        });

    }
};